export class ObjectBuilder {
    constructor(fields = [], objects = {}, args = {}, fragmentApplications = [], inlineFragments = {}, objectName) {
        Object.defineProperty(this, "fields", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: fields
        });
        Object.defineProperty(this, "objects", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: objects
        });
        Object.defineProperty(this, "args", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: args
        });
        Object.defineProperty(this, "fragmentApplications", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: fragmentApplications
        });
        Object.defineProperty(this, "inlineFragments", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: inlineFragments
        });
        Object.defineProperty(this, "objectName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: objectName
        });
    }
    argument(name, value) {
        return new ObjectBuilder(this.fields, this.objects, { ...this.args, [name]: value }, this.fragmentApplications, this.inlineFragments, this.objectName);
    }
    name(name) {
        return new ObjectBuilder(this.fields, this.objects, this.args, this.fragmentApplications, this.inlineFragments, name);
    }
    field(name) {
        return new ObjectBuilder([...this.fields, name], this.objects, this.args, this.fragmentApplications, this.inlineFragments, this.objectName);
    }
    object(name, builder) {
        if (!(builder instanceof ObjectBuilder)) {
            builder = builder(new ObjectBuilder());
        }
        return new ObjectBuilder(this.fields, { ...this.objects, [name]: builder }, this.args, this.fragmentApplications, this.inlineFragments, this.objectName);
    }
    inlineFragment(typeName, builder) {
        if (!(builder instanceof ObjectBuilder)) {
            builder = builder(new ObjectBuilder());
        }
        return new ObjectBuilder(this.fields, this.objects, this.args, this.fragmentApplications, { ...this.inlineFragments, [typeName]: builder }, this.objectName);
    }
    applyFragment(fragmentName) {
        return new ObjectBuilder(this.fields, this.objects, this.args, [...this.fragmentApplications, fragmentName], this.inlineFragments, this.objectName);
    }
}
//# sourceMappingURL=ObjectBuilder.js.map